import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import React from 'react';
import { colors } from '../utils/theme';
import Fade from '@mui/material/Fade';
import { styled } from '@mui/material/styles';

type StyledTooltipProps = TooltipProps & { isDarkMode?: boolean };

const StyledTooltip = styled(
  ({ isDarkMode, className, ...props }: StyledTooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  )
)(({ isDarkMode }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: isDarkMode
      ? colors.greys.GREY_900
      : colors.greys.BASE_WHITE,
    color: isDarkMode ? colors.greys.BASE_WHITE : colors.greys.GREY_700,
    boxShadow:
      '0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)',
    paddingTop: 16,
    paddingBottom: 16,
    paddingLeft: 24,
    paddingRight: 24,
    fontSize: 14,
    lineHeight: 1.3,
    fontWeight: 300,
    whiteSpace: 'pre-line',
    '.MuiTooltip-arrow': {
      color: isDarkMode ? colors.greys.GREY_900 : colors.greys.BASE_WHITE,
    },
  },
}));

export const RootineTooltip = ({
  tooltipProps,
  isDarkMode = false,
}: {
  tooltipProps: TooltipProps;
  isDarkMode?: boolean;
}): JSX.Element => {
  return (
    <StyledTooltip
      {...tooltipProps}
      arrow
      TransitionComponent={Fade}
      isDarkMode={isDarkMode}
    />
  );
};
